<template>
    <el-dialog
        title="发布"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        width="50%">
        <div class="dialog-container">
            <p class="dialogTit">{{ $t('views.columnpublish') }}</p>
            <div class="category-list">
                <div class="category-item" v-for="(item, index) in dataList"  @click="selectCategory(item.path)">
                    <img :src="item.icon" />
                    <h3 class="category-title">{{ item.title }}</h3>
                    <p class="category-desc">{{ item.content }}</p>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'PublishModal',
    data() {
        return {
            dialogVisible: false,
            dataList: [
                {
                    title: this.$t('index.life'),
                    content: this.$t('views.housekeeping'),
                    icon: require("@/assets/images/pIcon01.png"),
                    path: '/merchantAdd'
                },
                {
                    title: this.$t('index.recruit'),
                    content: this.$t('views.finance2'),
                    icon: require("@/assets/images/pIcon02.png"),
                    path: '/recruitmentAdd'
                },
                {
                    title: this.$t('index.youknow'),
                    content: this.$t('views.exploration'),
                    icon: require("@/assets/images/pIcon03.png"),
                    path: '/easyBookAdd'
                }
            ]
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        visible() {
            this.dialogVisible = this.visible;
            if (!this.dialogVisible) return;
        }
    },
    methods: {
        handleClose() {
            this.$emit("handleAction", true);
        },
        selectCategory(path) {
            this.$emit("handleAction", true);
            this.$router.push({
                path: path
            })
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped>
.dialog-container {
    padding: 10px 40px 30px;
}
.category-list {
    display: flex;
    gap: 25px;
}
.category-item {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #fff;
    padding: 35px 30px;
}
.category-item > img {
    width: 40px;
    margin-bottom: 20px;
}
.category-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin: 0;
    margin-bottom: 20px;
}
.category-desc {
    font-size: 14px;
    line-height: 1.5;
    color: #606266;
}
.dialogTit {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar/publishModal.vue